import { useEffect } from 'react';

const TawkTo = () => {
  useEffect(() => {
    // Tawk.to configuration
    window.Tawk_API = window.Tawk_API || {};
    //var Tawk_LoadStart = new Date();

    // Load Tawk.to script
    (function() {
      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];

      s1.async = true;
      s1.src = 'https://embed.tawk.to/691ff4bc61f1ea196badb965/1jaid80sb';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');

      s0.parentNode.insertBefore(s1, s0);
    })();

    // Optional: Customize widget appearance and behavior
    window.Tawk_API = window.Tawk_API || {};

    // Wait for widget to load, then customize
    window.Tawk_API.onLoad = function() {
      console.log('Tawk.to chat widget loaded successfully');

      // You can customize the widget here
      // Example: Set custom attributes
      window.Tawk_API.setAttributes({
        'name': 'Visitor',
        'email': '',
        'hash': ''
      }, function(error) {
        if (error) {
          console.error('Error setting Tawk.to attributes:', error);
        }
      });
    };

    // Clean up function
    return () => {
      // Remove Tawk.to widget when component unmounts (optional)
      const tawkScript = document.querySelector('script[src*="tawk.to"]');
      if (tawkScript) {
        tawkScript.remove();
      }

      // Remove Tawk widget iframe
      const tawkWidget = document.getElementById('tawkId');
      if (tawkWidget) {
        tawkWidget.remove();
      }
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default TawkTo;
